import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggSingleGroupPickerToLegacyField: FieldTransformer = (node) => {
	const value =
		node.selectedGroup != null
			? {
					groupId: node.selectedGroup.groupId,
					name: node.selectedGroup.name,
				}
			: null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			type: 'group',
			renderer: PLAIN_TEXT,
			custom: node.type,
			system: null,
			items: null,
			configuration: null,
		},
	};
};
